// providers/microsoftDynamics365.ts
import * as Api from '@ViewModels';
import { provider, toggle } from './helpers';

export const microsoftDynamics365Config = provider(Api.IntegrationProvider.MicrosoftDynamics365Sales, {
	displayName: 'Microsoft Dynamics 365',

	main: {
		writebacks: true,
		fields: [
			toggle('preferNicknameAsFirstName', {
				label: 'Prefer Nickname as First Name',
				subtitle: 'Use the contact nickname from Microsoft Dynamics 365 as the first name in Levitate',
			}),
		],
	},

	keyFacts: {
		birthdayDisplay: false,
		customDateFields: {
			label: 'Custom Fields',
			subtitle: 'Select custom date fields to be used as key facts',
		},
	},

	tags: {
		coreTags: true,
		customFields: true,
	},
});
